import React, { useCallback } from "react";
import { createPortal } from "react-dom";
import { Formik, } from "formik";
import { Modal, Spinner } from "react-bootstrap";
import { Entity } from "app/models/entity";
import { isNotEmptyOrZero } from "_metronic/helpers";
import { EntityForm } from "app/modules/tp/builders/FormBuilder";
import { FormComponent } from "./FormComponent";

export type ActionCallback<T> = (e: T) => Promise<boolean>;

export type Action<T> = {
    label: string,
    onClick: ActionCallback<T>
}

export type callbackNames = 'cancel' | 'destroy' | 'save' | 'duplicate' | 'reload';

export type Actions<T> = Record<callbackNames, Action<T>>

export type iconTitle = {
    icon: string | React.ReactNode,
    label: string
}

export type ModalEntityProps<T extends Entity> = {
    title: string | iconTitle
    actions: Actions<T>
    eform: EntityForm<T> | Promise<EntityForm<T>>
    initialEntity?: T
    show?: boolean
    loading?: boolean
    error?: JSX.Element
    message?: JSX.Element
    noDelete?: boolean
    noSave?: boolean
}

const modalsRoot = document.getElementById('root-modals') || document.body;

const cleanNestedModel = <T,>(e: T) => {
    //TODO: the select should take responsability of filling the object
    let cleanedEntity: T = { ...e };
    //for (const key in e) {
    //    const field = e[key] as any;
    //    if (typeof field === 'object' && field !== null && !Array.isArray(field) && (field.id)) {
    //        cleanedEntity = { ...cleanedEntity, [key]: field.id }
    //    }
    //    if (Array.isArray(field) && field.length > 0 && typeof field[0] === 'object' && field[0] !== null) {
    //        cleanedEntity = { ...cleanedEntity, [key]: field.map((f: any) => f.id) }
    //    }
    //}
    return cleanedEntity;
}

export default function SimpleModalEntity<T extends Entity>({ title, actions, eform: Eform, show, initialEntity = {} as T, loading = false, error = <></>, message = <></>, noDelete = false, noSave = false }: ModalEntityProps<T>) {

    const { cancel, save, duplicate } = actions;
    const entity = cleanNestedModel({...initialEntity});
    const [form, setForm] = React.useState<EntityForm<T> | null>(null)
    const [key, setKey] = React.useState(0);

    React.useEffect(() => {
        if (show) {
            setKey(key + 1)
        }
    }, [initialEntity])

    const isUpdating = React.useMemo(() => isNotEmptyOrZero(entity.id), [entity.id])

    const modalMessageBlock = React.useRef<HTMLDivElement>(null);

    const handleAction = async (action: ActionCallback<T>, e: T) => {
        if (await action(e)) {
        }
    }

    const titleLabel = useCallback(() => (
        typeof title === 'string' ? title : title.label
    ), [title])

    React.useEffect(() => {
        Promise.resolve(Eform).then((eform) => {
            setForm(eform);
        });
    }, [Eform]);


    return createPortal(
        <Modal
            className="tp-modal"
            id={`modal-${titleLabel()}-${entity.id ?? '0'}`}
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-900px tp-modal-dialog'
            show={show}
            onHide={() => cancel.onClick(entity)}
            backdrop="static"
        >
            {form !== null ?
                <>
                    <Formik
                        validateOnMount={true}
                        key={`form-${entity.id ?? '0'}-${key}`}
                        initialValues={entity}
                        validationSchema={form.validationRules}
                        onSubmit={async (values, { setSubmitting}) => {
                            modalMessageBlock.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
                            setSubmitting(true)
                            handleAction(save.onClick, values)
                        }}
                    >
                        {(formik) => {
                            return ( <FormComponent <T>
                                title={title}
                                actions={actions}
                                form={form}
                                show={show}
                                initialEntity={entity}
                                loading={loading}
                                error={error}
                                message={message}
                                noDelete={noDelete}
                                noSave={noSave}
                                formik={formik}
                                modalMessageBlock={modalMessageBlock} />
                            );
                        }}
                    </Formik></> : <Spinner animation="border" variant="primary" />
            }
        </Modal >,
        modalsRoot
    );
}
